/**
 * `localStorage` wrapped so a locked-down browser (private/incognito mode
 * with storage disabled, an enterprise policy, a full quota, etc.) degrades
 * this app to "no persistence" instead of crashing. A raw `localStorage.*`
 * call can throw synchronously in those environments — reading it during
 * `FirmaCurentaContext`'s `useState` initializer would take down the whole
 * authenticated tree on first render. Every localStorage access in the app
 * goes through this module — see the grep in the Task 8a fix report.
 */

export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage unavailable — the app carries on with in-memory state only.
  }
}

export function safeRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage unavailable — nothing to clean up.
  }
}
